import { Component, Input, OnInit } from '@angular/core';
import { User } from '../../core/UserManager';
import { Output, EventEmitter } from '@angular/core';
import PubSub from 'pubsub-js'

@Component({
  selector: 'filter-table',
  templateUrl: './filter.component.html',
})
export class FilterComponent implements OnInit {
  @Input() user: User;
  arrayTable: [];
  uniqueGroups: any[];
  uniqueStatus: any[];
  cloneArrayTable: any[] = [];
  eventUpdate: any;
  eventClean: any;

  ngOnInit() {

    this.eventUpdate = PubSub.subscribe('new-data', (msg, data)=>{
      this.cloneArrayTable = data;

      this.arrayTable = [];
      // @ts-ignore
      this.cloneArrayTable.forEach(val => this.arrayTable.push(Object.assign({}, val)));

      //this.arrayTable.forEach(val => this.cloneArrayTable.push(Object.assign({}, val)));

      this.uniqueGroups = [
        ...new Set(this.arrayTable.map((item: any) => item.group_name)),
      ].sort();
      this.uniqueStatus = [
        ...new Set(this.arrayTable.map((item: any) => item.status)),
      ].sort();
    });

    this.eventUpdate = PubSub.subscribe('filter-clean', (msg, data)=>{
      this.cleanFilter(false);
    });


  }

  cleanFilter(controlEvent:boolean = true){
    // @ts-ignore
    window.$('#nome-file').val("");
    // @ts-ignore
    window.$('#stato-caricamento').val("-1");
    // @ts-ignore
    window.$('#data-caricamento-from').val("");
    // @ts-ignore
    window.$('#data-caricamento-to').val("");
    // @ts-ignore
    window.$('#gruppo').val("-1");
    if(controlEvent) this.filterTable();
  }

  ngOnDestroy() {
    if(this.eventUpdate){
      PubSub.unsubscribe(this.eventUpdate);
    }
    if(this.eventClean){
      PubSub.unsubscribe(this.eventClean);
    }
  }

  filterTable() {

    const filterParams = {
      // @ts-ignore
      file_name: window.$('#nome-file').val(),
      // @ts-ignore
      status: window.$('#stato-caricamento').val(),
      // @ts-ignore
      dataCaricamentoDa: window.$('#data-caricamento-from').val(),
      // @ts-ignore
      dataCaricamentoA: window.$('#data-caricamento-to').val(),
      // @ts-ignore
      group_name: window.$('#gruppo').val()
    };

    Object.keys(filterParams).forEach((key) => {
      if (!filterParams[key] && filterParams[key] === '' || filterParams[key] === "-1") {
        delete filterParams[key];
      }
    });

    //@ts-ignore
    this.arrayTable = this.cloneArrayTable.filter((item) => {
      //@ts-ignore
      if (filterParams.status && filterParams.status !== "-1" && item.status != filterParams.status) {
        return false;
      }
      //@ts-ignore
      if (filterParams.file_name && item.file_name.toLowerCase().indexOf(filterParams.file_name.toLowerCase()) === -1) {
        return false;
      }
      //@ts-ignore
      if (filterParams.dataCaricamentoDa){
        if(this.getTime(item.creation_date) < new Date(filterParams.dataCaricamentoDa).getTime()){
          return false;
        }
      }

      //@ts-ignore
      if (filterParams.dataCaricamentoA){
        if(this.getTime(item.creation_date) > new Date(filterParams.dataCaricamentoA).getTime()) {
          return false;
        }
      }

      //@ts-ignore
      if (filterParams.group_name && filterParams.group_name !== "-1" && item.group_name != filterParams.group_name) {
        return false;
      }
      return true;
    });
    PubSub.publish('filter-data', this.arrayTable);
  }

  getTime(dateString) {
    let date = dateString.split(" ")[0].split("/");
    return new Date(date[2]+"-"+date[1]+"-"+date[0]).getTime();
  }
}
